import { render, staticRenderFns } from "./floatingWidget.vue?vue&type=template&id=5823f170&scoped=true&lang=pug&"
import script from "./floatingWidget.vue?vue&type=script&lang=js&"
export * from "./floatingWidget.vue?vue&type=script&lang=js&"
import style0 from "./floatingWidget.vue?vue&type=style&index=0&id=5823f170&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5823f170",
  null
  
)

export default component.exports